export const locale = {
  lang: 'de',
  data: {
    'PORTAL': {
      'BTN_SCREE_SHO':'Bildschirmfoto machen',
      'TOTALCOLA':'Mitarbeiter insgesamt',
      'TOTALFAL': 'Mitarbeiter, die noch nicht geantwortet haben',
      'TOTALCONT':'Mitarbeiter, die bereits geantwortet haben',
      'TOTALPRO':'Gesamtfortschritt',
      'TOTALLOG':'Mitarbeiter, die ihre Umfrage nicht beendet haben',
      'REPORTE':'Empfohlene Anzahl von Beantwortungen für...',
      'RANKING':'Minimale Anzahl von Beantwortungen für...',
      'TOOLT_REPORTE':'Empfohlene Anzahl von Beantwortungen für die Lieferung statistisch signifikanter Ergebnisse nach demografischem Cut-off',
      'TOOLT_RANKING':'Mindestanzahl an Beantwortungen für die Zertifizierung/das Ranking des Unternehmens',

      'REPORTE_CER_CARCA':'Empfohlene Anzahl von Beantwortungen, um...',
      'TOOLT_REPORTE_CER_CARCA':'Empfohlene Anzahl der Beantwortungen, um statistische Ergebnisse nach demografischem Cut-off zu erhalten, wobei berücksichtigt wird, dass jede Option 5 Beantwortungen erhalten wird',
      'RANKING_CER_CARCA':'Mindestanzahl von Antworten für...',
      'TOOLT_RANKING_CER_CARCA':'Mindestanzahl von Antworten für die Zertifizierung / das Ranking der Organisation ',

      'REPORTE_MED_CARCA':'Empfohlene Anzahl von Beantwortungen, um...',
      'TOOLT_REPORTE_MED_CARCA':'Empfohlene Anzahl der Beantwortungen, um statistische Ergebnisse nach demografischem Cut-off zu erhalten, wobei berücksichtigt wird, dass jede Option 5 Beantwortungen erhalten wird',
      'RANKING_MED_CARCA':'Mindestanzahl von Antworten für...',
      'TOOLT_RANKING_MED_CARCA':'Mindestanzahl von Antworten für die Zertifizierung / das Ranking der Organisation',

      'TOTALMIN':'Mitarbeiter-Minimum erforderlich',
      'TOTALGONE':'Mitarbeiter, die nicht geantwortet haben',
      'SELECTFPLA':'Filter',
      'TBARRAPROGRESO':'Aktueller Fortschritt',
      'ACCESODENEGADO': 'Abgelaufene Zugangsverbindung',
      'ACCESOMSJPRE_1': 'Der Schlusstermin der Umfrage ist erreicht, das Portal ist noch  ',
      'ACCESOMSJPRE_2': ' Tage lang aktiv.',
      'BTNOK': 'OK',
      'DIARESTA':'Verbleibender Tag',
      'NO-INFO':'Fehlende Informationen in der Mitarbeiterdatenbank',
      'COLAB':'Mitarbeiter',
      'PORTAL_V1':'Zählportal V1',
      'PORTAL_V2':'Zählportal V2',
      'DI-TRANSCU':'Verstrichene Tage',
      'ETI_GRAFI_ZONA_HO': 'Das im Diagramm angezeigte Datum ist auf die Ortszeit in: ',
      'ETI_FILT_V1&V2': 'Die mit ( * ) gekennzeichneten Gruppen zeigen keine Informationen an, da sie nicht die für die Fortschrittsanzeige erforderliche Mindestanzahl von Benutzern haben ',
      'WAR_RESU_ARE_MIN5': 'Die Mindestanzahl der Antworten zur Anzeige der Ergebnisse pro Bereich beträgt 5',
      'FILTROS':{
        '1': 'Land',
        '2': 'Ort',
        '3': 'Bereich - Abteilung',
        '4': 'Akademischer Grad',
        '5': 'Abteilung',
        '6': 'Geografische Ebene 1',
        '7': 'Geografische Ebene 2',
        '8': 'Geografische Ebene 3',
        '9': 'Geografische Ebene 4',
        '10': 'Geografische Ebene 5',
        '11': 'Geografische Ebene 6',
        '12': 'Geografische Ebene 7',
        '13': 'Geografische Ebene 8',
        '14': 'Geografische Ebene 9',
        '15': 'Geografische Ebene 10',
        '16': 'Strukturebene 1',
        '17': 'Strukturebene 2',
        '18': 'Strukturebene 3',
        '19': 'Strukturebene 4',
        '20': 'Strukturebene 5',
        '21': 'Strukturebene 6',
        '22': 'Strukturebene 7',
        '23': 'Strukturebene 8',
        '24': 'Strukturebene 9',
        '25': 'Strukturebene 10',
        '26': 'Geschäftsfeld',
        '27': 'Strukturebene 2',
      },
      'COLUMNAS_TABLA':{
        'NIVEL1': 'Level 1',
        'NIVEL2': 'Ebene 2',
        'DEMOGRAFICO': 'Demografisch',
        'SEGMENTO': 'Segment',
        'COLABORADORES_T': 'Gesamtzahl der Mitarbeiter',
        'PENDIENTES_RESPONDER': 'Mitarbeiter, die noch nicht geantwortet haben',
        'YA_RESPONDIERON': 'Mitarbeiter, die bereits geantwortet haben',
        'AVANCE': 'Vorschau',
        'FILTERS': 'Filter'
      },
      'EXCEL_V2':{
        'TITULO_AVANCE': 'Fortschritte bei der Durchführung der Umfrage durch: ',
        'SHEET': 'Bericht',
        'DESCARGA': 'Zählportal von: ',
        'MODAL_DESCARGA': 'Richtiges Herunterladen'
      },
      'ETIQUETAS':{
        'ETIQUETAS': 'Artikel pro Seite',
        'OF': 'von',
        'BOTON':'Filter zurücksetzen'
      },
      'FILTROS_V2':{
        'ninguno': 'Keine',
        'Company': 'Firma',
        'country': 'Land',
        'location': 'Standort',
        'area': 'Bereich',
        'antiquity': 'Altertum',
        'generation': 'Generation',
        'charge': 'Ladung',
        'homologado': 'Homologado',
        'gender': 'Geschlecht',
        'typeofwork': 'Art der Arbeit',
        'workCondition': 'Arbeitsbedingungen',
        'academico': 'Akademischer Abschluss',
        'contratacion': 'Art des Vertrags',
        'personal': 'Art des Personals',
        'geo_1': 'Geografische Ebene 1',
        'geo_uno': 'Geografische Ebene 1',
        'geo_2': 'Geografische Ebene 2',
        'geo_3': 'Geografische Ebene 3',
        'geo_4': 'Geografische Ebene 4',
        'geo_5': 'Geografische Ebene 5',
        'geo_6': 'Geografische Ebene 6',
        'geo_7': 'Geografische Ebene 7',
        'geo_8': 'Geografische Ebene 8',
        'geo_9': 'Geografische Ebene 9',
        'geo_10': 'Geografische Ebene 10',
        'structure_1': 'Strukturebene 1',
        'structure_2': 'Strukturebene 2',
        'structure_3': 'Strukturebene 3',
        'structure_4': 'Strukturebene 4',
        'structure_5': 'Strukturebene 5',
        'structure_6': 'Strukturebene 6',
        'structure_7': 'Strukturebene 7',
        'structure_8': 'Strukturebene 8',
        'structure_9': 'Strukturebene 9',
        'structure_10': 'Strukturebene 10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': 'Strukturebene 1',
        'structure_DOS': 'Strukturebene 2',
        'structure_TRES': 'Strukturebene 3',
        'structure_CUATRO': 'Strukturebene 4',
        'structure_CINCO': 'Strukturebene 5',
        'structure_SEIS': 'Strukturebene 6',
        'structure_SIETE': 'Strukturebene 7',
        'structure_OCHO': 'Strukturebene 8',
        'structure_NUEVE': 'Strukturebene 9',
        'structure_DIEZ': 'Strukturebene 10',
        'bUnit': 'Geschäftseinheit',
      },
      'FILTROS_V2_HK':{
        'ninguno': 'Keine',
        'Company': 'Firma',
        'country': 'Land',
        'location': 'Standort',
        'area': 'Abteilung',
        'antiquity': 'Altertum',
        'generation': 'Generation',
        'charge': 'Position oder Funktion im Unternehmen',
        'homologado': 'Homologado',
        'gender': 'Geschlecht',
        'typeofwork': 'Art der Arbeit',
        'workCondition': 'Arbeitsbedingungen',
        'academico': 'Akademischer Abschluss',
        'contratacion': 'Art des Vertrags',
        'personal': 'Art des Personals',
        'geo_1': 'Geografische Ebene 1',
        'geo_uno': 'Geografische Ebene 1',
        'geo_2': 'Geografische Ebene 2',
        'geo_3': 'Geografische Ebene 3',
        'geo_4': 'Geografische Ebene 4',
        'geo_5': 'Geografische Ebene 5',
        'geo_6': 'Geografische Ebene 6',
        'geo_7': 'Geografische Ebene 7',
        'geo_8': 'Geografische Ebene 8',
        'geo_9': 'Geografische Ebene 9',
        'geo_10': 'Geografische Ebene 10',
        'structure_1': 'Strukturebene 1',
        'structure_2': 'Strukturebene 2',
        'structure_3': 'Strukturebene 3',
        'structure_4': 'Strukturebene 4',
        'structure_5': 'Strukturebene 5',
        'structure_6': 'Strukturebene 6',
        'structure_7': 'Strukturebene 7',
        'structure_8': 'Strukturebene 8',
        'structure_9': 'Strukturebene 9',
        'structure_10': 'Strukturebene 10',
        //////CLAVES PARA PORTAL DE CONTEOS///
        'structure_uno': 'Strukturebene 1',
        'structure_DOS': 'Strukturebene 2',
        'structure_TRES': 'Strukturebene 3',
        'structure_CUATRO': 'Strukturebene 4',
        'structure_CINCO': 'Strukturebene 5',
        'structure_SEIS': 'Strukturebene 6',
        'structure_SIETE': 'Strukturebene 7',
        'structure_OCHO': 'Strukturebene 8',
        'structure_NUEVE': 'Strukturebene 9',
        'structure_DIEZ': 'Strukturebene 10',
        'bUnit': 'Geschäftseinheit',
      },
      'PRODUCTO':{
        'CERT': 'Zertifizieren',
        'MED': 'Messen',
        'NOM35': 'Norm 035',
        'PULSE': 'Pulsecheck',
        'FOCUS': 'Fokusbereich',
        'MEDIR_1': 'Messung erweitert',
        'MEDIR_2': 'Messung + MST',
        'MEDIR_3': 'Messung nach Bereichen',
        'MEDIR_4': 'Messung durch Führungskräfte',
        'MEDIR_5': 'Messung nach Dimensionen',
        'MEDIR_6': 'Messung zur Bescheinigung',
        'NAME': 'Firma: ',
        'PRODUCTO':'Produkt: ',
        'PORTAL':'Zählportal',
        'LEADER_GO':'Leader Go',
        'AMCO':'AMCO',
        'TRAB_DIGN':'Anständige Arbeit',
        'PRI_EMPLE':'Erster Job',

      },
      'EXCEL':{
        'NOMBOTON': 'Excel exportieren',
        'NOMBOTONREDUCIDO': 'Export nach Excel reduziert',
        'NOMEMPRE': 'FIRMENNAME:',
        'NOMUSUARIO': 'BENUTZERNAME:',
        'NOMPROD': 'PRODUKTNAME:',
        'FERTILITY': 'EINFÜHRUNGSDATUM:',
        'FECHDESCA': 'DATUM DES DOWNLOADS:',
        'DRESTAN': 'RESTLICHER TAG:',
        'TOTALCOLA': 'MITARBEITER GESAMT:',
        'TOTALCONT': 'MITARBEITER, DIE BEREITS GEANTWORTET HABEN:',
        'TOTALFAL': 'MITARBEITER, DIE NOCH NICHT GEANTWORTET HABEN:',
        'TOTALPRO': 'GESAMTFORTSCHRITT:',
        'REPORT': 'RESPONSE RATE FOR DELIVERABLES (minimum 85%):',
        'RANKING': 'STICHPROBE FÜR ZERTIFIZIERUNG UND RANKING:',
        'FILT': 'FILTER:',
        'NOMFILT':' FILTER NAME:',
        //pestaña principal
        'INFOGENE': 'Allgemeiner Bericht',
        'FILTROSNAME':{
          'country':'Land',
          'location':'ort',
          'gebiet':'gebiet',
          'antiquity':'antiquity',
          'generation':'generation',
          'charge':'charge',
          'homologado':'homologado',
          'gender':'Geschlecht',
          'typeofwork':'typeofwork',
          'workCondition':'workCondition',
          'academico':'academico',
          'contratacion':'contratacion',
          'personal': 'personal',
          'geo_1':'geo_1',
          'geo_2':'geo_2',
          'geo_3':'geo_3',
          'geo_4':'geo_4',
          'geo_5':'geo_5',
          'structure_1':'struktur_1',
          'structure_2':'struktur_2',
          'structure_3':'struktur_3',
          'structure_4':'struktur_4',
          'structure_5':'struktur_5',
          'structure_6':'struktur_6',
          'structure_7':'struktur_7',
          'structure_8':'struktur_8',
          'structure_9':'struktur_9',
          'structure_10':'struktur_10',
        }
      },
      'TIPO-PERSONAL':{
        'TIPO':'Personal Type',
        '1':'Syndiziert',
        '2':'Trust',
        '3':'Beide',
      }

    },
    'PORTAL35': {
      'TOTALCOLA':'Mitarbeiter insgesamt',
      'TOTALFAL': 'Mitarbeiter, die noch nicht geantwortet haben',
      'TOTALCONT':'Mitarbeiter, die bereits geantwortet haben',
      'TOTALPRO': 'Stichprobe',
      'SELECTFPLA': 'Betriebsstätte',
      'TBARRAPROGRESO':'Gesamtfortschritt',
      'TOTALLOG':'Mitarbeiter, die ihre Umfrage nicht beendet haben',
      'TOTALGONE':'Mitarbeiter, die sich entschieden haben, nicht zu antworten',
      'FILTROS':{
        '1': 'Arbeitsplatz',
        '2': "Land",
        '3': 'Ort',
        '4': 'Gebiet',
        '5': 'Akademischer Grad',
        '6': 'Abteilung',
        '7': 'Geografische Ebene 1',
        '8': 'Geografische Ebene 2',
        '9': 'Geografische Ebene 3',
        '10': 'Geografische Ebene 4',
        '11': 'Strukturelle Ebene 1',
        '12': 'Strukturelle Ebene 2',
        '13': 'Strukturelle Ebene 3',
        '14': 'Geografische Ebene 8',
        '15': 'Geografische Ebene 9',
        '16': 'Geografische Ebene 10',
        '17': 'Hierarchische Ebene 1',
        '18': 'Hierarchische Ebene 2',
        '19': 'Hierarchische Ebene 3',
        '20': 'Hierarchische Ebene 4',
        '21': 'Hierarchische Ebene 5',
        '22': 'Hierarchische Ebene 6',
        '23': 'Hierarchische Ebene 7',
        '24': 'Hierarchische Ebene 8',
        '25': 'Hierarchische Ebene 9',
        '26': 'Hierarchische Ebene 10',
      }

    },
    'BTN':{
      'USERS':'Mitarbeiter'
    }
  }

};
